var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"shopping-cart-empty"},[_c('img',{staticClass:"shopping-cart-empty__image lazyload",attrs:{"src":require("@/assets/images/toshiba/account-empty.png")}}),_c('div',{staticClass:"shopping-cart-empty__txt"},[_vm._v(_vm._s(_vm.cartEmptyTxt))])])
}
var staticRenderFns = []

export { render, staticRenderFns }